(function () {
  var config = window.PM_IMAGE_TRANSLATOR_CONFIG || {};
  var translationsByLocale = window.PM_IMAGE_TRANSLATIONS || {};

  var locale = (config.locale || "").toLowerCase();
  var host = (config.host || window.location.host || "").toLowerCase();

  if (host.indexOf("pilatesme-deutschland.com") !== -1) locale = "de";
  if (host.indexOf("pilatesme-france.com") !== -1) locale = "fr";

  var translations = translationsByLocale[locale] || {};
  if (!translations || Object.keys(translations).length === 0) return;

  function getFileName(url) {
    if (!url) return "";
    try {
      var cleanUrl = url.split("?")[0];
      var parts = cleanUrl.split("/");
      return parts[parts.length - 1] || "";
    } catch (e) {
      return "";
    }
  }

  function replaceSrcset(srcset) {
    if (!srcset) return srcset;

    return srcset
      .split(",")
      .map(function (part) {
        var trimmed = part.trim();
        if (!trimmed) return trimmed;

        var bits = trimmed.split(/\s+/);
        var rawUrl = bits[0];
        var descriptor = bits.slice(1).join(" ");

        var fileName = getFileName(rawUrl);
        var replacement = translations[fileName];

        if (!replacement) return trimmed;
        return descriptor ? replacement + " " + descriptor : replacement;
      })
      .join(", ");
  }

  function replaceElement(el) {
    if (!el || !el.getAttribute) return;

    ["src", "data-src", "poster"].forEach(function (attr) {
      var value = el.getAttribute(attr);
      if (!value) return;

      var fileName = getFileName(value);
      var replacement = translations[fileName];

      if (replacement) {
        el.setAttribute(attr, replacement);
      }
    });

    ["srcset", "data-srcset"].forEach(function (attr) {
      var value = el.getAttribute(attr);
      if (!value) return;

      var updated = replaceSrcset(value);
      if (updated !== value) {
        el.setAttribute(attr, updated);
      }
    });

    if (el.style && el.style.backgroundImage) {
      var bg = el.style.backgroundImage;
      var match = bg.match(/url\(["']?(.*?)["']?\)/i);

      if (match && match[1]) {
        var fileName = getFileName(match[1]);
        var replacement = translations[fileName];
        if (replacement) {
          el.style.backgroundImage = 'url("' + replacement + '")';
        }
      }
    }
  }

  function runReplace(root) {
    var scope = root || document;

    if (scope.nodeType === 1) {
      replaceElement(scope);
    }

    scope.querySelectorAll("img, source, video, [style*='background']").forEach(replaceElement);
  }

  document.addEventListener("DOMContentLoaded", function () {
    runReplace(document);
  });

  window.addEventListener("load", function () {
    runReplace(document);
  });

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) {
          runReplace(node);
        }
      });
    });
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();